var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center p-4 cursor-pointer ml-auto",on:{"click":_vm.toggleFavourite}},[_vm._v(" Favourite "),_c('ion-icon',{staticClass:"fs-3 ml-1",attrs:{"name":_vm.starIcon}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }